const ShopSideNav = () => {
  return null;
};

export default ShopSideNav;
